import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import clsx from 'clsx';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';
import * as api from '_core/utils/api';


export const FloatValue = React.memo((props) => {
  const {
    l,
    
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : Number(value) || 0;
});

export const FloatFilter = React.memo((props) => {
  const {
    l,
    classes,
    
    filterValue,
    setFilterValue,
    
    filterApply,
    filterReset
  } = props;
  
  
  return (
    <>
      <Divider />
      
      <ListItem className={classes.filterInputFromTo}>
        <div>
          <OutlinedInput
            className={classes.filterInput}
            fullWidth
            margin="none"
            value={filterValue?.from || ''}
            onChange={(event) => { const value = event.target.value; setFilterValue((state) => ({ from: value, to: state?.to || '' })); }}
            startAdornment={l('$global.field.period.from')}
          />
        </div>
        
        <div>
          <OutlinedInput
            className={classes.filterInput}
            fullWidth
            margin="none"
            value={filterValue?.to || ''}
            onChange={(event) => { const value = event.target.value; setFilterValue((state) => ({ from: state?.from || '', to: value })); }}
            startAdornment={l('$global.field.period.to')}
          />
        </div>
      </ListItem>
    </>
  );
});

export const FloatTags = React.memo((props) => {
  const {
    l,
    classes,
    
    filterApply,
    column,
    value
  } = props;
  
  
  return (
    <>
      {Number.isFinite(value.from) ? (
        <div className={classes.statusChip}>
          {l('$global.field.period.from')}
          &nbsp;
          {value.from}
          
          <a href="" onClick={(event) => { event.preventDefault(); filterApply({ from: '', to: value.to }); }}><ClearIcon /></a>
        </div>
      ) : null}
      
      {Number.isFinite(value.to) ? (
        <div className={classes.statusChip}>
          {l('$global.field.period.to')}
          &nbsp;
          {value.to}
          
          <a href="" onClick={(event) => { event.preventDefault(); filterApply({ from: value.from, to: '' }); }}><ClearIcon /></a>
        </div>
      ) : null}
    </>
  );
});

export const getFloatApiParam = (column, value) => {
  const from = !math.isEmpty(value.from) ? Number(value.from) : '';
  const to = !math.isEmpty(value.to) ? Number(value.to) : '';
  
  if (!Number.isFinite(from) && !Number.isFinite(to))
    return;
  
  return (Number.isFinite(from) ? from : '')
    + ':' + (Number.isFinite(to) ? to : '');
};

export const getFloatExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  return value === undefined ? '-' : Number(value) || 0;
};
